if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }
      hide(preventFocus = false) {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        const cartNotification = document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
  
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
  
      show(opener) {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const productUrl = new URL(opener.getAttribute('data-product-url'), window.location.origin);
        const currentSearchParams = new URLSearchParams(window.location.search);
        currentSearchParams.forEach((value, key) => {
          if (!productUrl.searchParams.has(key)) {
            productUrl.searchParams.set(key, value);
          }
        });
  
        fetch(productUrl.toString())
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            const productFormScriptSrc = responseHTML.querySelector('script[src*="product-form.js"]')?.src;
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            return this.ensureProductFormScript(productFormScriptSrc).then(() => {
              this.enableVariantInputs();
  
              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
  
              if (window.ProductModel) window.ProductModel.loadShopifyXR();
  
              //this.removeGalleryListSemantic();
              this.preventVariantURLSwitching();
              super.show(opener);
            });
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
          });
      }
  
      setInnerHTML(element, html) {
        element.innerHTML = html;
  
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach(oldScriptTag => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value)
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      enableVariantInputs() {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        this.modalContent.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((input) => {
          input.disabled = false;
        });
      }

      ensureProductFormScript(src) {
        if (customElements.get('product-form')) return Promise.resolve();
        if (!src) return Promise.resolve();

        if (!window.__wtProductFormPromise) {
          window.__wtProductFormPromise = new Promise((resolve) => {
            const existingScript = document.querySelector(`script[src="${src}"]`);
            if (existingScript) {
              resolve();
              return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => resolve();
            document.head.appendChild(script);
          }).then(() =>
            Promise.race([
              customElements.whenDefined('product-form'),
              new Promise((resolve) => setTimeout(resolve, 1500))
            ])
          );
        }

        return window.__wtProductFormPromise;
      }
  
      preventVariantURLSwitching() {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        const variants = this.modalContent.querySelector('variant-radios');
        if( variants ) variants.setAttribute('data-update-url', 'false');
      }
  
      removeDOMElements() {
        const productModal = this.productElement.querySelector('product-modal');
        const shippingModal = this.productElement.querySelector('[id^="ShippingModal-"]');
        if (productModal) productModal.remove();
        if (shippingModal) shippingModal.remove();
      }
  
      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
        this.productElement.querySelectorAll('variant-radios').forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
        });
      }
  
      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
  
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }
    });
  } 
